export type RangePreset = 'next7' | 'next30' | 'thisMonth' | 'nextMonth';

function iso(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function presetRange(preset: RangePreset, today: Date = new Date()): { start: string; end: string } {
  const base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  switch (preset) {
    case 'next7': {
      const end = new Date(base); end.setDate(base.getDate() + 6);
      return { start: iso(base), end: iso(end) };
    }
    case 'next30': {
      const end = new Date(base); end.setDate(base.getDate() + 29);
      return { start: iso(base), end: iso(end) };
    }
    case 'thisMonth': {
      const start = new Date(base.getFullYear(), base.getMonth(), 1);
      const end = new Date(base.getFullYear(), base.getMonth() + 1, 0);
      return { start: iso(start), end: iso(end) };
    }
    case 'nextMonth': {
      const start = new Date(base.getFullYear(), base.getMonth() + 1, 1);
      const end = new Date(base.getFullYear(), base.getMonth() + 2, 0);
      return { start: iso(start), end: iso(end) };
    }
  }
}
